
export default [{
    // path: '/futures/market/:explore?',
    path: '/futures/market',
    name: 'market',
    component: () => import('@/pages/market'),
    meta: {
        i18n: {
            zh_CN: () => require("@/i18n/lang/market/zh.js"),
            en_US: () => require("@/i18n/lang/market/en.js"),
            ko_KR: () => require("@/i18n/lang/market/kr.js"),
            zh_TW: () => require("@/i18n/lang/market/tw.js"),
            vi_VN: () => require("@/i18n/lang/market/vi.js"),
            id_ID: () => require("@/i18n/lang/market/ba.js"),
            tr_TR: () => require("@/i18n/lang/market/tr.js"),
            ru_Ru: () => require("@/i18n/lang/market/ru.js"),
            fr_FR: () => require("@/i18n/lang/market/fr.js")
        }
    }
}]



// WEBPACK FOOTER //
// ./src/router/market.js